module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull2#Contents-A"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Center para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic char-style-override-2"
  }, [_vm._v("For Karl, who introduced me to the tundra and The People."), _c('br'), _vm._v("For Egon, Hal, and Jon, who shared the magic."), _c('br'), _vm._v("And in memory of Claire for making it possible.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93bd5276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/The_Spirit_and_the_Skull3.vue
// module id = 69
// module chunks = 0